.root {
  position: fixed;
  top: 0;
  right: 0;
  z-index: var(--z-over-intercom);
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 550px;
  height: 100%;
  overflow: hidden;
  color: var(--modal-color);
  background: var(--modal-background);
  transform: translateX(100%);
  transition: transform 320ms;
}

.open {
  transform: translateX(0);
}

.padX {
  padding-right: 3rem;
  padding-left: 3rem;

  @media (--md-down) {
    padding-right: 1rem;
    padding-left: 1rem;
  }
}

.header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  height: var(--nav-height-desktop);
  border-bottom: 1px solid var(--gray-400);

  .closeButton {
    margin-right: -1rem;
  }

  & > * {
    margin: 0;
  }
}

.content {
  position: relative;
  top: 0;
  padding-top: 1.5rem;
  overflow-x: hidden;
  overflow-y: scroll;

  &:not(:last-child) {
    padding-bottom: 100px;
  }
}

.footer {
  position: sticky;
  bottom: 0;
  display: flex;
  gap: 1rem;
  padding-top: 1.5rem;
  padding-bottom: calc(env(safe-area-inset-bottom) + 1.5rem);
  margin-top: auto;
  background: var(--surface);
  border-top: 1px solid var(--gray-400);
}
